module.exports = __webpack_public_path__ + "static/slide-6-4715e29302dbaa2ba21494c6258298d4.jpg";